import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { pickFilterSearch } from '../../lib/router/itemsSearchSchema';

const CreateAssetGroupPage = lazy(() =>
  import('../../pages/items/CreateAssetGroupPage').then((m) => ({ default: m.CreateAssetGroupPage })),
);

export const Route = createFileRoute('/items/create')({
  validateSearch: (search: Record<string, unknown>) => pickFilterSearch(search),
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <CreateAssetGroupPage />
    </Suspense>
  ),
});
